// Generated by CoffeeScript 1.11.1
(function() {
  var RSVP;

  RSVP = require('rsvp');

  module.exports = {
    toBase64: function() {
      var canvas, context, i, imageData, j, len, pixel, pixelData, ref;
      canvas = document.createElement('canvas');
      canvas.width = this.width();
      canvas.height = this.height();
      context = canvas.getContext('2d');
      imageData = context.getImageData(0, 0, this.width(), this.height());
      pixelData = imageData.data;
      ref = this.pixelData;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        pixel = ref[i];
        pixelData[i] = pixel;
      }
      context.putImageData(imageData, 0, 0);
      return canvas.toDataURL('image/png');
    },
    toPng: function() {
      var dataUrl, image;
      dataUrl = this.toBase64();
      image = new Image();
      image.width = this.width();
      image.height = this.height();
      image.src = dataUrl;
      return image;
    },
    saveAsPng: function() {
      throw "Not available in the browser. Use toPng() instead.";
    }
  };

}).call(this);
